import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import CreateBatchView from '../batch/CreateBatchView';
import CreateAdjustmentsBatchView from '../batch/CreateAdjustmentsBatchView';
import batchModeModel from './BatchModeModel';
import batchPageModel from './BatchPageModel';
import BatchSummaryView from './BatchSummaryView';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
  },
  viewTabsRoot: {
    justifyContent: 'center',
    margin: '0px 0px 10px 0px',
    padding: '0px 20px',
  },
  divider: {
    marginBottom: '8px',
  },
  batchView: {
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    overflowY: 'auto',
  },
  batchSummaryView: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flex: 1,
  },
  batchSummary: {},
});

interface IBatchPageViewProps {}

type BatchPageViewProps = WithStyle<ReturnType<typeof styles>, IBatchPageViewProps>;

class BatchPageView extends React.PureComponent<BatchPageViewProps> {
  constructor(props: BatchPageViewProps) {
    super(props);
  }

  componentWillUnmount() {
    batchPageModel.reset();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Observe
          render={() => {
            switch (batchModeModel.mode) {
              case 'Summary':
                return (
                  <div className={classes.batchSummaryView}>
                    <BatchSummaryView className={classes.batchSummary} />
                  </div>
                );

              case 'Adjustments':
                return (
                  <div className={classes.batchView}>
                    <CreateAdjustmentsBatchView />
                  </div>
                );

              default:
                return (
                  <div className={classes.batchView}>
                    <CreateBatchView />
                  </div>
                );
            }
          }}
        />
      </div>
    );
  }
}

export default withStyles<IBatchPageViewProps>(styles, BatchPageView);
